import {
  IconArrowDown,
  IconArrowUp,
  type TablerIcon,
} from '@tabler/icons-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SortDirection } from '../utils/sortValue.ts';

export interface ISortDirectionOption {
  value: SortDirection;
  icon: TablerIcon;
  label: string;
}

/**
 * Opzioni di direzione (Ascendente/Discendente) con icona + etichetta. Hook
 * condiviso dal bottone [FilterBarSortPopover] (icona/testo della direzione
 * corrente) e dal contenuto [FilterBarSortPopoverContent] (la Select direzione):
 * così le etichette asc/desc vivono in un solo punto.
 */
export function useSortDirectionOptions(): ISortDirectionOption[] {
  const { t } = useTranslation();
  return useMemo(
    () => [
      {
        value: SortDirection.Asc,
        icon: IconArrowUp,
        label: t(
          'search.component.order-row.select-direction.option.asc',
          'Ascendente',
        ),
      },
      {
        value: SortDirection.Desc,
        icon: IconArrowDown,
        label: t(
          'search.component.order-row.select-direction.option.desc',
          'Discendente',
        ),
      },
    ],
    [t],
  );
}
